<template>
    <div class="timetable container">
        <div class="row" v-if="timetable">
            <div class="col-12">
                <p>{{timetable.Mode.toUpperCase()}} (NUMBER {{timetable.ServiceNumber}})</p>
            </div>
            <div class="col-12 mt-3">
                <table v-if="timetable.Mode" class="table table-responsive table-headers-vertical table-bordered">
                    <tbody>
                        <tr v-for="(stop, stopsIndex) in timetable.timetable.stops" :key="stopsIndex">
                            <th>{{ stop }}</th>
                            <td v-for="(column, columnIndex) in timetable.timetable.columns"
                                :key="columnIndex">
                                {{ column[stopsIndex] ? formatTime(column[stopsIndex]) : '-' }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'timetable',
    props: ['timetable'],
    methods: {
        formatTime(time) {
            return moment.parseZone(time).format('HH:mm')
        },
    },
}
</script>
<style scoped>
    table.table-bordered {
        border: none;
    }
</style>
